"use client";
import React, { useRef, useEffect, useState } from "react";
import { useScroll, useTransform, motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/Elecinstallation.css";

import video2022 from "../assets/WETEX2022.mp4";
import video2023 from "../assets/WETEX2023.mp4";
import video2024 from "../assets/WETEX2024.mp4";
// import video2025 from "../assets/WETEX2025.mp4";

const VideoYearTimeline = () => {
  const timelineRef = useRef(null);
  const containerRef = useRef(null);
  const [timelineHeight, setTimelineHeight] = useState(0);

  /* 1️⃣ Initialize AOS */
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  /* 2️⃣ Calculate Timeline Height Properly */
  useEffect(() => {
    const calculateAndUpdateTimelineHeight = () => {
      if (timelineRef.current) {
        const newHeight =
          timelineRef.current.getBoundingClientRect().height;

        setTimelineHeight((prevHeight) => {
          if (newHeight > 0 && (newHeight !== prevHeight || prevHeight === 0)) {
            return newHeight;
          }
          return prevHeight;
        });
      }
    };

    const handleLayoutReady = () => {
      calculateAndUpdateTimelineHeight();
      AOS.refresh();
    };

    const initialCalcTimer = setTimeout(
      calculateAndUpdateTimelineHeight,
      50
    );

    if (document.readyState === "complete") {
      const readyTimer = setTimeout(handleLayoutReady, 100);
      return () => clearTimeout(readyTimer);
    } else {
      window.addEventListener("load", handleLayoutReady);
    }

    window.addEventListener("resize", handleLayoutReady);

    return () => {
      clearTimeout(initialCalcTimer);
      window.removeEventListener("load", handleLayoutReady);
      window.removeEventListener("resize", handleLayoutReady);
    };
  }, []);

  /* 3️⃣ Scroll Animation */
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 10%", "end 50%"],
  });

  const heightTransform = useTransform(
    scrollYProgress,
    [0, 1],
    [0, timelineHeight]
  );

  const opacityTransform = useTransform(
    scrollYProgress,
    [0, 0.1],
    [0, 1]
  );

  const timelineData = [
    { title: "WETEX 2022", video: video2022 },
    { title: "WETEX 2023", video: video2023 },
    { title: "WETEX 2024", video: video2024 },
    // { title: "WETEX 2025", video: video2025 },
  ];

  return (
    <div className="elec-design-hero-container" ref={containerRef}>
      <div className="elec-design-hero-header video-header">
        <h2 className="elec-design-hero-title">
          Our Exhibition Journey
        </h2>
        <p className="elec-design-hero-description">
          A visual showcase of our participation in WETEX exhibitions
          demonstrating innovation and sustainability.
        </p>
      </div>

      <div ref={timelineRef} className="elec-design-hero-timeline">
        {timelineData.map((item, index) => (
          <div key={index} className="elec-design-hero-step">

            {/* LEFT SIDE YEAR */}
            <div className="elec-design-hero-sticky">
              <div className="elec-design-hero-marker-outer">
                <div className="elec-design-hero-marker-inner" />
              </div>
              <h3 className="elec-design-hero-step-title-desktop">
                {item.title}
              </h3>
            </div>

            {/* RIGHT SIDE VIDEO */}
            <div className="elec-design-hero-step-content">
              <h3 className="elec-design-hero-step-title-mobile">
                {item.title}
              </h3>

              <video
                className="elec-design-hero-step-image"
                autoPlay
                loop
                muted
                playsInline
                controls={false}
                data-aos="fade-left"
              >
                <source src={item.video} type="video/mp4" />
              </video>
            </div>
          </div>
        ))}

        {/* ✅ Progress Bar only if height exists */}
        {timelineHeight > 0 && (
          <div
            style={{ height: `${timelineHeight}px` }}
            className="elec-design-hero-progress-bar-wrapper"
          >
            <motion.div
              style={{
                height: heightTransform,
                opacity: opacityTransform,
              }}
              className="elec-design-hero-progress-bar"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoYearTimeline;
